<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
       <template slot="imageSlot" slot-scope="{ row }">
        <div style="display: flex; align-items: center">
          <el-popover placement="right-start" title="" trigger="hover">
            <div style="width: 250px; height: 250px">
              <el-image
                :src="`${row.image}`"
                style="width: 100%; height: 100%"
              >
                <el-image
                  slot="error"
                  :src="no_pic"
                  style="width: 100%; height: 100%"
                ></el-image>
              </el-image>
            </div>
            <el-image
              slot="reference"
              :src="`${row.image}`"
              style="width: 60px; height: 60px; margin-top: 5px"
            >
              <el-image
                slot="error"
                :src="no_pic"
                style="width: 60px; height: 60px; margin-top: 5px"
              ></el-image>
            </el-image>
          </el-popover>
        </div>
      </template>
      <template slot="titleSlot"  slot-scope="{row}">
        <el-tooltip effect="dark" :content="row.title" placement="top">
          <span class="line-ellipsis">{{ row.title }}</span>
        </el-tooltip>
      </template>
      <template slot="statusSlot" slot-scope="{row}">
        <span>{{statusMap[row.status]}}</span>
      </template>
      <template slot="errorMessageSlot" slot-scope="{row}">
        <el-tooltip popper-width="400px" class="item" effect="dark" :content="row.errorMessage" placement="top">
          <span class="line-ellipsis">{{row.errorMessage}}</span>
        </el-tooltip>
      </template>
      <template slot="operationSlot" slot-scope="{row}">
        <el-button v-if="row.status === 1" type="link" @click="handleEvent(row.baseItemId)">编辑分销商品</el-button>
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import tableMixins from '@mixins/table-mixins';
import no_pic from "@/assets/images/no_pic.png";
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
    info: [String, Object],
    isSku: {
      type: String,
      default: "",
    }
  },
  mixins: [new tableMixins(208)],
  components: {
    TableList,
  },
  data() {
    return {
      no_pic,
      statusMap:{
        '-1':'执行中',
        0: '失败',
        1: '成功',
        2: '部分成功',
        4: '已终止',
      }
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'distributorDetail'],),
    cols() {
      let _cols = [];
      if (this.isSku) {
        _cols = [
          { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
          { prop: "outerId", attrs: { label: "款式编码"} },
          { prop: "skuOuterId", attrs: { label: "SKU编码"} },
          { prop: "title", attrs: { label: "商品名称" },slot: true },
          { prop: "status", attrs: { label: "状态" }, slot: true},
          { prop: "errorMessage", attrs: { label: "失败原因" ,}, slot: true},
        ]
      } else {
        _cols = [
          { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
          { prop: "outerId", attrs: { label: "款式编码"} },
          { prop: "title", attrs: { label: "商品名称" },slot: true },
          { prop: "status", attrs: { label: "状态" }, slot: true},
          { prop: "errorMessage", attrs: { label: "失败原因" ,}, slot: true}
        ]
      }
      if (['加入分销商品', '更新分销商品', '分销商品更新新增sku'].includes(this.info.channel)) {
        _cols.push({ prop: "operation", attrs: { label: "操作" }, slot: true});
      }
      return _cols;
    }
  },
  methods: {
    ...mapMutations(['setCurrentPage']),
    ...mapActions(['setRePublishRowData', 'setDisplayRePublishRowData', 'setDistributorDetail']),
    handleEvent(baseItemId) {
      if (!baseItemId) {
        this.$message.error('编辑商品失败：baseItemId缺失；');
        return;
      }
      this.$emit('edit', baseItemId)
    }
  },
};
</script>

<style lang="scss" scoped>
.errorMessage{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

</style>
